<template>
    <v-dialog v-model="value" persistent :max-width="maxWidth">
        <v-card>
            <v-card-title class="primary modal-title">
                <span>{{ title }}</span>
                <v-spacer/>
                <v-btn icon @click="fecharModal">
                    <v-icon size="20" color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text style="overflow-x: hidden">
              <div class="box-modal-confirm">
                 <div style="text-align: center">
                     <span class="text-modal-confirm" v-if="text">{{text}}</span><br>
                     <span class="text-modal-confirm" v-if="secondText">{{secondText}}</span>
                     <div v-if="mensagemRascunho">
                       <br v-if="text || secondText">
                       <span class="text-modal-rascunho" >{{ mensagemRascunho }}<strong>NÃO</strong> foi enviado.</span>
                     </div>
                 </div>
              </div>
            </v-card-text>
            <div class="az-actions-form actions-modal">
                <button class="action-secundary-button" @click="cancelarAcao">Não</button>
                <button class="action-primary-button" @click.prevent="confirmarAcao">
                    {{ textConfirm }}
                </button>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalConfirmarEtapaAnexo',
        props: {
            value: Boolean,
            title: {
                type: String
            },
            textConfirm:{
              type: String,
              default: 'Sim, continuar'
            },
            text: {
                type: String
            },
            secondText:{
                type: String
            },
            mensagemRascunho:{
              type: String
            },
            maxWidth: {
                type: String,
                default: '650'
            }
        },
        methods: {
            fecharModal() {
                this.$emit('fecharModalConfirm')
            },
            cancelarAcao() {
                this.$emit('cancelarAcao')
            },
            confirmarAcao() {
                this.$emit('confirmarAcao')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .text-modal-confirm
        color #3A6861
        font-weight bold

    .text-modal-rascunho
        color #FFBF00
        font-weight bold

    .box-modal-confirm
        display flex
        flex-direction column
        justify-content center
        align-items center
        min-height 100px
</style>